import type { ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: none;

  ${({ theme }) => theme.device.tablet} {
    display: block;
  }
`;

export interface MobileBlockProps {
  children: ReactNode;
  className?: string;
}

export function MobileBlock({ children, className }: MobileBlockProps) {
  return <Wrapper className={className}>{children}</Wrapper>;
}
